<template>
  <div id="allmap"></div>
</template>

<script>
export default {
  data(){
    return {
      markerPoint:{lng: 108.951, lat:34.3285},
      show:false,
      isBig:false,
      values:[],
      position:{lng: 108.951, lat:34.3285}
    }
  },
  methods:{
    handler ({BMap, map}) {
      // console.log(BMap, map) //地图组件渲染完毕时触发，返回一个百度地图的核心类和地图实例
      let _this = this //设置一个临时变量指向vue实例，因为在百度地图回调里使用this，指向的不是vue实例
      this.BMap = BMap //将BMAP类和map实例赋值给变量BMAP和map
      this.map = map
    },

    getLocation(){
      var map = new BMapGL.Map("allmap");
      var point = new BMapGL.Point(116.331398,39.897445);
      map.centerAndZoom(point,12);

      var geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(function(r){
        if(this.getStatus() == BMAP_STATUS_SUCCESS){
          this.position={lng:r.point.lng,lat:r.point.lat};
          this.markerPoint={lng:r.point.lng,lat:r.point.lat};
          var mk = new BMap.Marker(r.point);
          map.addOverlay(mk);
          map.panTo(r.point);
          alert('您的位置：' + r.point.lng + ',' + r.point.lat);
        }
        else {
          alert('failed' + this.getStatus());
        }
      });
    }
  },
  mounted() {
    this.getLocation();
  }
}
</script>

<style>
html{height:100%}
body{height:100%;margin:0px;padding:0px}
.dynamic{
  display: flex;
  position: relative;
}
/* 地图 */
.bm-view {
  width: 100vw;
  height: 100vh;
}
h3 {
  font-size: 14px;
  line-height: 35px;
  padding: 0 10px;
  background: #f8f8f8;
  border: 1px solid #ddd;
  border-left: 0;
}
.map h3,.mapBig h3,.information h3{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.map h3 i,.mapBig h3 i{
  font-weight: 700;
  font-size: 17px;
  cursor: pointer;
}
.information h3 img{
  display: block;
  width: 25px;
  transform: rotateY(180deg);
}
</style>



// WEBPACK FOOTER //
// src/components/location.vue